import { BonusCardFront } from "@/Components/BonusCardFront"
import PropertyBidCard from "@/Components/PropertyBigCard"
import { useAppDispatch, useAppSelector } from "@/store/hooks"
import { setState } from "@/store/globalSlice"
import { getCellByOrderAndMapId } from "@/utils/gameHelpers"
import { useRef, useEffect, useState } from "react"

export const HoveredTooltipItem: React.FC = () => {
  const dispatch = useAppDispatch()
  const hoveredItem = useAppSelector((state) => state.global.hoveredItem)
  const mapId = useAppSelector((state) => state.global.myGame?.settings.mapId)
  const tooltipRef = useRef<HTMLDivElement>(null)
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 })
  const [translate, setTranslate] = useState({ x: 0, y: 0 })

  // Track the cursor and own dismissal centrally. While an item is hovered we
  // follow the mouse, and we hide the tooltip as soon as the cursor is over
  // neither a hover source (a small card) nor the tooltip itself. Centralizing
  // this here (instead of in each card's onMouseLeave) avoids the tooltip
  // getting stranded when a card unmounts mid-hover or when the cursor crosses
  // from the card onto the area the tooltip occupies.
  useEffect(() => {
    if (!hoveredItem) return

    const handleMouseMove = (e: MouseEvent) => {
      setMousePosition({ x: e.clientX, y: e.clientY })

      const target = e.target as HTMLElement | null
      const stillHovering =
        target && (target.closest("[data-hover-source]") || target.closest("#item-tooltip"))

      if (!stillHovering) {
        dispatch(setState({ hoveredItem: undefined }))
      }
    }

    window.addEventListener("mousemove", handleMouseMove)
    return () => window.removeEventListener("mousemove", handleMouseMove)
  }, [hoveredItem, dispatch])

  // Calculate tooltip position and handle overflow
  useEffect(() => {
    if (tooltipRef.current && hoveredItem) {
      const tooltipWidth = tooltipRef.current.offsetWidth
      const tooltipHeight = tooltipRef.current.offsetHeight
      const screenWidth = window.innerWidth
      const screenHeight = window.innerHeight

      const { x: mouseX, y: mouseY } = mousePosition

      let translateX = 0
      let translateY = 0

      // Check if tooltip overflows horizontally
      if (mouseX + tooltipWidth > screenWidth) {
        translateX = -100 // Move tooltip to the left of the cursor
      }

      // Check if tooltip overflows vertically
      if (mouseY + tooltipHeight > screenHeight) {
        translateY = -100 // Move tooltip above the cursor
      }

      setTranslate({ x: translateX, y: translateY })
    }
  }, [mousePosition, hoveredItem])

  if (!hoveredItem) return null
  if (!mapId) return null

  if (hoveredItem.type === "property") {
    const cell = getCellByOrderAndMapId(
      hoveredItem?.propertyOrder,
      mapId
    ) as ICell

    return (
      <div
        ref={tooltipRef}
        className="fixed pointer-events-none"
        id="item-tooltip"
        style={{
          top: mousePosition.y,
          left: mousePosition.x,
          transform: `translate(${translate.x}%, ${translate.y}%)`,
          zIndex: 300,
        }}
      >
        <PropertyBidCard cell={cell}></PropertyBidCard>
      </div>
    )
  }

  return (
    <div
      ref={tooltipRef}
      className="fixed pointer-events-none"
      id="item-tooltip"
      style={{
        top: mousePosition.y,
        left: mousePosition.x,
        transform: `translate(${translate.x}%, ${translate.y}%)`,
        zIndex: 40,
      }}
    >
      {/* <BonusCardFront
        card={hoveredItem.card}
        type={hoveredItem.card.type}
      ></BonusCardFront> */}
    </div>
  )
}
